import { useMutation, useQuery } from '@tanstack/react-query';
import { useHistory, useParams } from 'react-router-dom';

import { ROUTES } from 'features/routes';
import { getData } from 'services/api';
import { IdParamsType } from 'utils/types';
import { updateEvent } from './services';
import { Event } from './types';
import { sendGAEvent } from 'utils/utils';

export const useEditEventApi = () => {
	const { push } = useHistory();
	const { id }: IdParamsType = useParams();

	const { data: event } = useQuery({
		queryKey: ['event', id],
		queryFn: (): Promise<Event> => getData(`events/${id}`),
		select: (eventData: Event) => {
			return {
				...eventData,
				custom_fees: eventData.custom_fees.map(({ taxable, general, ...rest }) => ({
					...rest,
					taxable: taxable ? '1' : '0',
					general: general ? '1' : '0',
				})),
			};
		},
	});
	const { mutate: editEvent } = useMutation(updateEvent, {
		onSuccess: () => {
			sendGAEvent({ category: 'Journeys', action: 'Edit event' });
			push(ROUTES.DASHBOARD_PATH.replace(':id', id));
		},
	});

	return { event, editEvent };
};
